// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-layout {
  width: 100vw;
  min-height: 100vh;
  background-color: transparent;
  position: relative;
  display: flex;
  flex-direction: column;
}
.public-layout .content {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0;
}
.public-layout .content > .login-page {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/layouts/PublicLayout/PublicLayout.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AADF;AAGE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AADJ;AAII;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AAFN","sourcesContent":["// PublicLayout.scss - Optimized for Login Page\n\n.public-layout {\n  width: 100vw;\n  min-height: 100vh;\n  background-color: transparent;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  \n  .content {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    \n\n    & > .login-page {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
